import { textFragment } from '../../graphql/fragments/textFragment';
import { weblinkFragment } from '../../graphql/fragments/weblinkFragment';
import { graphql } from '../../graphql/graphql';

const helmetFragment = graphql(`
  fragment Helmet on StreetPage_Page {
    helmet {
      canonical
      title
      description
      siteName
    }
  }
`);

const breadCrumbsFragment = graphql(`
  fragment BreadCrumbs on StreetPage_Page {
    breadCrumbs {
      title
      url
    }
  }
`);

const titleFragment = graphql(`
  fragment Title on StreetPage_Page {
    title {
      parts
    }
  }
`);

const suburbInsightsBannerFragment = graphql(
  `
    fragment SuburbInsightsBanner on StreetPage_Page {
      suburbInsightsBanner @include(if: $toggleSuburbCTA) {
        title
        insights {
          ...Text
        }
        cta {
          ...WebLink
        }
        disclaimerText
      }
    }
  `,
  [textFragment, weblinkFragment],
);

const propertyCollectionsFragment = graphql(`
  fragment PropertyCollections on StreetPage_Page {
    propertyCollections {
      subtitle
      title
      collectionType
      properties {
        address
        path
        imageV2 {
          alt
          jpgUri: uri(width: 224, height: 126, imageMode: Crop, progressive: true)
          webpUri: uri(width: 224, height: 126, format: WEBP, imageMode: Crop, progressive: true)
        }
        badge {
          text
          variant
        }
        priceV2 {
          display
          sourceLevel
        }
        features {
          iconNameV2
          title
          hoverTitle
          valueWithUnit
        }
        soldDate
        clickThroughTracking {
          pathname
          page
          element
          sourceType
        }
      }
      tracking {
        showMoreProperties {
          schema
          data {
            event_name
            in_page_source
            user_action
          }
        }
      }
    }
  }
`);

const propertiesFragment = graphql(`
  fragment Properties on StreetPage_Page {
    properties {
      title
      subtitle
      items {
        visible {
          link {
            url
            title
          }
        }
        hidden {
          link {
            url
            title
          }
        }
      }
      showMoreButton {
        title
      }
    }
  }
`);

const mediaPartnerBannerFragment = graphql(
  `
    fragment MediaPartnerBanner on StreetPage_Page {
      mediaPartnerBanner {
        text
        link {
          ...WebLink
        }
      }
    }
  `,
  [weblinkFragment],
);

export const streetPageQuery = graphql(
  `
    query StreetPageBySlug($slug: StreetPageSlug!, $toggleSuburbCTA: Boolean = false) {
      streetPageBySlug(slug: $slug) {
        id
        vgDisclaimerHtml
        ...Helmet
        ...BreadCrumbs
        ...Title
        ...SuburbInsightsBanner
        ...PropertyCollections
        ...Properties
        ...MediaPartnerBanner
      }
    }
  `,
  [
    helmetFragment,
    breadCrumbsFragment,
    titleFragment,
    propertyCollectionsFragment,
    propertiesFragment,
    mediaPartnerBannerFragment,
    suburbInsightsBannerFragment,
  ],
);
